module.exports = __webpack_public_path__ + "static/img/ele.47d57f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/seriesPic/ele.png
// module id = QgAf
// module chunks = 1